import React, { PureComponent } from 'react';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {
  DateRangePicker,
  isSameDay,
  isInclusivelyAfterDay,
  isInclusivelyBeforeDay
} from 'react-dates';
import classnames from 'classnames';
import moment from 'moment';

import PropTypes from 'prop-types';

const yesterday = moment().subtract(1, 'days');
const weekAgo = moment().subtract(1, 'weeks');
const presets = [
  {
    text: 'Yesterday',
    start: yesterday,
    end: yesterday
  },
  {
    text: 'Last 7 days',
    start: weekAgo,
    end: yesterday
  },
  {
    text: 'Last 30 days',
    start: moment().subtract(30, 'days'),
    end: yesterday
  }
];

const isOutsideRange = day => {
  return (
    isInclusivelyAfterDay(day, moment().add(1, 'days')) ||
    isInclusivelyBeforeDay(day, moment('10-22-2018', 'MM-DD-YYYY'))
  );
};

class DatePicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: props.startDate || weekAgo,
      endDate: props.endDate || yesterday,
      lastSearchedEndDate: props.startDate || yesterday,
      lastSearchedStartDate: props.endDate || weekAgo
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDatesChange({ startDate, endDate }) {
    const { lastSearchedStartDate, lastSearchedEndDate } = this.state;
    if (
      startDate &&
      endDate &&
      (startDate !== lastSearchedStartDate || endDate !== lastSearchedEndDate)
    ) {
      this.props.onChange(
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD')
      );
      return this.setState({
        startDate,
        endDate,
        focusedInput: null,
        lastSearchedStartDate: startDate,
        lastSearchedEndDate: endDate
      });
    }
    this.setState({ startDate, endDate });
  }

  onFocusChange(focusedInput) {
    const {
      startDate,
      endDate,
      lastSearchedStartDate,
      lastSearchedEndDate
    } = this.state;
    let newState = { focusedInput };
    if (!focusedInput && !startDate && !endDate) {
      newState = {
        ...newState,
        startDate: lastSearchedStartDate,
        endDate: lastSearchedEndDate
      };
    }
    this.setState(newState);
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const { disabled } = this.props;

    return (
      <div className="reports-dates">
        <DateRangePicker
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDateId="startDateId"
          startDate={startDate}
          endDateId="endDateId"
          endDate={endDate}
          minimumNights={0}
          disabled={disabled}
          displayFormat="DD/MM/YYYY"
          isOutsideRange={isOutsideRange}
          initialVisibleMonth={() => moment().subtract(1, 'month')}
          calendarInfoPosition="top"
          keepFocusOnInput={false}
          showClearDates
          reopenPickerOnClearDates
        />
        <div className="duration">
          {presets.map(({ text, start, end }) => {
            const isSelected =
              isSameDay(start, startDate) && isSameDay(end, endDate);
            return (
              <span
                className={classnames({ active: isSelected })}
                key={text}
                onClick={() =>
                  !isSelected &&
                  this.onDatesChange({ startDate: start, endDate: end })
                }
              >
                {text}
              </span>
            );
          })}
        </div>
      </div>
    );
  }
}

DatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  disabled: PropTypes.bool
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/formFields/DatePicker.js